export default __webpack_public_path__ + "placeholder.62132e83.png";